import React, { useEffect, useReducer, useState } from 'react'
import { Container, Typography } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import { SearchOtInbound } from '../../components/PlannerOTInbound/SearchOtInbound'
import {
  otInboundReducer,
  reducerInitialState,
  searchInitialState
} from '../../components/PlannerOTInbound/otInboundReducer'
import { Filter } from '../../interfaces'
import { OTInboundElementList } from '../../components/PlannerOTInbound/GridElementOTInbound/OTInboundElementList'
import {
  DataGridSettings,
  SortField
} from '../../interfaces/DataGrid/DataGridSettings'
import { dataGridSettings } from '../../components/PlannerOTInbound/otInboundConfig'
import { apiCall, ApiConfig } from '../../config/api'
import {
  ISearchOTInbound,
  OtInboundPaginated
} from '../../interfaces/Planner/Planner'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { useDispatch, useSelector } from 'react-redux'
import { setShowSnackbar } from '../../redux/actions/otInboundAction'
import { RootState } from '../../redux/store'

export async function getOT(
  page?: number,
  pageSize?: number,
  sorters?: SortField[],
  filters?: Filter[]
): Promise<OtInboundPaginated> {
  const arrFilters: string[] | undefined =
    filters?.length === 0
      ? []
      : filters?.map(({ key, value }) => `${key}=${value}`)

  const strFilters: string =
    arrFilters?.length === 0 ? '' : `&${arrFilters?.join('&')}`

  const arrSorters: string[] = sorters
    ? sorters.map((sorter) => `sorters=${JSON.stringify(sorter)}`)
    : []

  const strSorters: string =
    arrSorters.length > 0 ? `&${arrSorters.join('&')}` : ''

  return await apiCall(
    'GET',
    `${ApiConfig.InboundApi}?pagesize=${pageSize}&pageIndex=${page}${strSorters}${strFilters}`
  )
    .then((response) => {
      return response.data
    })
    .catch((error) => console.log(error))
}

export const OtInboundPage = () => {
  const [state, dispatch] = useReducer(otInboundReducer, reducerInitialState)
  const [sorters, setSorters] = useState<SortField[]>(
    DataGridSettings.defaultSorters(dataGridSettings)
  )
  const { busqueda, totalItems, page, rowsPerPage, filters, rows, isLoading } =
    state

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: 'SET_BUSQUEDA',
      payload: {
        ...busqueda,
        [event.target.name]: event.target.value,
        ['searchFieldSecondary']: '',
        ['searchValueSecondary']: ''
      }
    })
  }

  const handleSecondSearch = (name: string, value: string) => {
    if (name === 'initialDate') {
      dispatch({
        type: 'SET_BUSQUEDA',
        payload: {
          ...busqueda,
          ['searchValue']: value
        }
      })
    } else {
      dispatch({
        type: 'SET_BUSQUEDA',
        payload: {
          ...busqueda,
          ['searchFieldSecondary']: name,
          ['searchValueSecondary']: value
        }
      })
    }
  }

  const resetearBusqueda = () => {
    dispatch({
      type: 'SET_BUSQUEDA',
      payload: searchInitialState
    })
  }

  const reduxDispatch = useDispatch()

  const { snackbar } = useSelector((state: RootState) => state.otInbound)

  const hideSnackbar = () => {
    reduxDispatch(setShowSnackbar(false, '', 'success'))
  }

  const handleGetOTInbound = () => {
    dispatch({ type: 'SET_IS_LOADING', payload: true })
    getOT(page, rowsPerPage, sorters, filters).then(
      (response: OtInboundPaginated) => {
        if (response !== undefined) {
          if (response.items) {
            dispatch({ type: 'SET_ROWS', payload: response.items })
            dispatch({ type: 'SET_TOTAL_ITEMS', payload: response.totalItems })
          }

          dispatch({ type: 'SET_IS_LOADING', payload: false })
        }
      }
    )
  }
  const handleGet = () => {
    dispatch({ type: 'SET_IS_LOADING', payload: true })
    getOT(page, rowsPerPage, [], filters).then(
      (response: OtInboundPaginated) => {
        if (response !== undefined) {
          if (response.items.length > 0) {
            dispatch({ type: 'SET_ROWS', payload: response.items })
            dispatch({ type: 'SET_TOTAL_ITEMS', payload: response.totalItems })
          }
        }
        dispatch({ type: 'SET_IS_LOADING', payload: false })
      }
    )
  }

  const fetchFilteredData = () => {
    const searchOtInbound: ISearchOTInbound = busqueda
    const filters: string[] = []
    filters[searchOtInbound.searchField] = searchOtInbound.searchValue
    filters[searchOtInbound.searchFieldSecondary] =
      searchOtInbound.searchValueSecondary
    dispatch({
      type: 'SET_FILTERS',
      payload: filters
        ? Object.keys(filters)
            .filter((key) => filters[key] !== '')
            .map<Filter>((key) => ({
              key: key,
              value: filters[key].toString()
            }))
        : []
    })
  }

  useEffect(() => {
    handleGetOTInbound()
  }, [rowsPerPage, page, sorters, filters])

  const handlePageSizeChange = (event: SelectChangeEvent<number>) => {
    dispatch({ type: 'CHANGE_PAGE', payload: 0 })
    dispatch({
      type: 'CHANGE_PAGE_SIZE',
      payload: Number(event.target.value)
    })
  }

  const handlePageChange = (updatePage: number) => {
    dispatch({ type: 'CHANGE_PAGE', payload: updatePage - 1 })
  }

  const handleOnSortChanged = (sorters: SortField[]) => {
    setSorters(sorters)
  }

  return (
    <Container maxWidth='xl'>
      <Typography variant='h4' component='h2' gutterBottom>
        Gestionar OT de Ingreso
      </Typography>

      <SearchOtInbound
        search={busqueda}
        handleSearch={handleSearch}
        handleSearchSecondary={handleSecondSearch}
        handleResetBusqueda={resetearBusqueda}
        handleFetchFilteredData={fetchFilteredData}
        handleGetOt={handleGet}
      />

      <OTInboundElementList
        otInbound={rows}
        page={page + 1}
        totalPages={Math.ceil(totalItems / rowsPerPage)}
        pageSize={rowsPerPage}
        handlePagination={handlePageChange}
        handlePageSize={handlePageSizeChange}
        sorters={sorters!}
        handleOnSortChanged={handleOnSortChanged}
        isLoadingConfirm={isLoading}
        handleGetOt={handleGet}
      />

      <SnackBar
        open={snackbar.open}
        setOpen={hideSnackbar}
        message={snackbar.message}
        status={snackbar.status}
      />
    </Container>
  )
}
